<template>
  <div>
    <div
      v-if="!user_data.parent_id && user_data.role == 'pro'"
      class="automate-all-section"
    >
      <b-card-text class="mb-0">
        Automate All
      </b-card-text>
      <div class="custom-control custom-switch custom-switch-danger">
        <input
          id="automate-all-toggle"
          v-model="automateAll"
          type="checkbox"
          class="custom-control-input"
          @change="triggerAutomateAll"
        >
        <label
          class="custom-control-label"
          for="automate-all-toggle"
        />
      </div>
    </div>
    <b-card
      v-if="mtIntStatus && zoomIntStatus"
      no-body
    >
      <b-card-header class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          Upcoming Classes
        </h4>
      </b-card-header>

      <b-card-body class="pb-0">
        <div class="table-responsive">
          <table class="table table-striped automate-table">
            <thead>
              <tr>
                <th>Time</th>
                <th class="automate-table__class-column" />
                <th>Location</th>
                <th>Date</th>
                <th>URL</th>
                <th>Automate</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!items.length">
                <td
                  colspan="6"
                  class="text-center text-muted py-3"
                >
                  No upcoming classes found.
                </td>
              </tr>

              <tr
                v-for="item in items"
                :key="item.id"
              >
                <td>
                  <div v-if="item.start_date">
                    <p class="mb-25">
                      <strong>{{ timeformat(item.start_time.substring(0, 5)) }}</strong>
                    </p>
                    <p class="mb-0">
                      {{ item.class_type.duration }} mins
                    </p>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <b-avatar
                      v-if="item.instructors[0]"
                      :src="item.instructors[0].photo_urls.thumbnail_url"
                      size="50px"
                    />
                    <div class="location-detail ml-2">
                      <h5 class="mb-25">
                        {{ item.name }}
                      </h5>
                      <p
                        v-if="item.instructors[0]"
                        class="mb-0"
                      >
                        {{ item.instructors[0].name }}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    v-if="item.location.name"
                    class="automate-table__location"
                  >
                    {{ item.location.name }}
                  </div>
                </td>
                <td>{{ dateformat(item.start_datetime) }}</td>
                <td>
                  <template v-if="zoomLinkFor(item) && zoomLinkFor(item).status">
                    <a
                      class="zoom-link-ui"
                      :href="zoomLinkFor(item).zoomurl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >{{ zoomLinkFor(item).zoomurl }}</a>
                  </template>
                  <template v-else>
                    -
                  </template>
                </td>
                <td>
                  <div class="custom-control custom-switch d-inline-block">
                    <input
                      :id="switchId('automate-class', item.id)"
                      :checked="toggleValueFor(item)"
                      :disabled="toggleDisabledFor(item)"
                      type="checkbox"
                      class="custom-control-input"
                      @change="toggleClassAutomation(item, $event.target.checked)"
                    >
                    <label
                      class="custom-control-label"
                      :for="switchId('automate-class', item.id)"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <nav
          v-if="totalPages > 1"
          aria-label="Class pagination"
          class="mt-2 mb-2"
        >
          <ul class="pagination justify-content-center mb-0">
            <li
              class="page-item"
              :class="{ disabled: pagination.page === 1 }"
            >
              <button
                type="button"
                class="page-link"
                :disabled="pagination.page === 1"
                @click="setPage(1)"
              >
                First
              </button>
            </li>
            <li
              class="page-item"
              :class="{ disabled: pagination.page === 1 }"
            >
              <button
                type="button"
                class="page-link"
                :disabled="pagination.page === 1"
                @click="setPage(pagination.page - 1)"
              >
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </button>
            </li>
            <li
              v-for="pageNumber in visiblePageNumbers"
              :key="pageNumber"
              class="page-item"
              :class="{ active: pageNumber === pagination.page }"
            >
              <button
                type="button"
                class="page-link"
                @click="setPage(pageNumber)"
              >
                {{ pageNumber }}
              </button>
            </li>
            <li
              class="page-item"
              :class="{ disabled: pagination.page === totalPages }"
            >
              <button
                type="button"
                class="page-link"
                :disabled="pagination.page === totalPages"
                @click="setPage(pagination.page + 1)"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </button>
            </li>
            <li
              class="page-item"
              :class="{ disabled: pagination.page === totalPages }"
            >
              <button
                type="button"
                class="page-link"
                :disabled="pagination.page === totalPages"
                @click="setPage(totalPages)"
              >
                Last
              </button>
            </li>
          </ul>
        </nav>
      </b-card-body>
    </b-card>
    <b-card
      v-else
      bg-variant="danger"
      text-variant="white"
    >
      <b-card-text>Please connect Zoom and/or Mariana Tek to begin automating classes.</b-card-text>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BAvatar, BCardBody, BCardHeader, BCardText, BCard
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardText,
    BAvatar,
  },
  data() {
    return {
      items: [],
      pagination: {
        page: 1,
        count: 0,
      },
      zoom_links: {},
      automateAll: false,
    }
  },
  computed: {
    mtIntStatus() {
      if(this.$store.state.app.integrationstate && this.$store.state.app.integrationstate.mariana && this.$store.state.app.integrationstate.mariana.status == 'connected'){
        return true
      }
      else{
        return false
      }
    },
    zoomIntStatus() {
      if(this.$store.state.app.integrationstate && this.$store.state.app.integrationstate.zoom && this.$store.state.app.integrationstate.zoom.status == 'connected'){
        return true
      }
      else{
        return false
      }
    },
    user_data() {
      return this.$store.state.app.user_data
    },
    totalPages() {
      const totalRows = Number(this.pagination.count) || 0
      return Math.max(1, Math.ceil(totalRows / 20))
    },
    visiblePageNumbers() {
      const maxButtons = 5
      const totalPages = this.totalPages
      const currentPage = this.pagination.page

      if (totalPages <= maxButtons) {
        return Array.from({ length: totalPages }, (_, index) => index + 1)
      }

      let start = Math.max(1, currentPage - 2)
      let end = Math.min(totalPages, start + maxButtons - 1)

      if (end - start + 1 < maxButtons) {
        start = Math.max(1, end - maxButtons + 1)
      }

      return Array.from({ length: end - start + 1 }, (_, index) => start + index)
    },
  },
  async mounted() {
    this.$store.commit('app/loadingState', true)
    var intState = this.$store.state.app.integrationstate
    if(Object.keys(intState).length === 0){
      this.$store.dispatch('app/getIntegrationStatus')
    }
    await this.$store.dispatch('app/getSubdomain')
    const automationData = await this.$http.post('https://live.ipstudio.co/api/get-usermeta', { meta_key: 'automate' })
    if(automationData.data.status != "failed"){
      const automationDataJSON = JSON.parse(automationData.data.meta_value);
      this.automateAll = automationDataJSON.status;
    }
    await Promise.all([
      this.loadClasses(1),
      this.loadZoomLinks(),
    ])
  },
  methods: {
    timeformat(time) {
      // Check correct time format and split into components
      time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) { // If time format correct
        time = time.slice (1);  // Remove full string match value
        time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join (''); // return adjusted time or original string
    },
    dateformat(dateiso) {
      const options = { year: "numeric", month: "long", day: "numeric" }
      return new Date(dateiso).toLocaleDateString(undefined, options)
    },
    buildClassesUrl(page) {
      const subdomain = this.$store.state.app.subdomain
      const userLocation = this.$store.state.app.user_data.location
      const date = new Date()
      const todaysdate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
        .toISOString()
        .split("T")[0]

      date.setDate(date.getDate() + 7)

      const enddate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
        .toISOString()
        .split("T")[0]

      const baseUrl = 'https://' + subdomain + '.marianatek.com/api/customer/v1/classes?min_start_date=' + todaysdate + '&max_start_date=' + enddate + '&is_live_stream=true&page_size=20&page=' + page

      if (userLocation != null) {
        return baseUrl + '&location=' + userLocation
      }

      return baseUrl
    },
    async loadClasses(page) {
      const normalizedPage = Math.max(1, Number(page) || 1)

      this.$store.commit('app/loadingState', true)

      try {
        const res = await this.$http.get(this.buildClassesUrl(normalizedPage))
        this.items = res.data.results || []
        this.pagination = {
          ...this.pagination,
          ...(res.data.meta ? res.data.meta.pagination : {}),
          page: normalizedPage,
        }
      } finally {
        this.$store.commit('app/loadingState', false)
      }
    },
    async loadZoomLinks() {
      const res = await this.$http.get('https://live.ipstudio.co/api/zoom-link')
      this.zoom_links = res.data || {}
    },
    setPage(page) {
      const nextPage = Math.min(this.totalPages, Math.max(1, Number(page) || 1))

      if (nextPage === this.pagination.page) return

      this.pagination = {
        ...this.pagination,
        page: nextPage,
      }

      this.loadClasses(nextPage)
    },
    switchId(prefix, id) {
      return prefix + '-' + id
    },
    zoomLinkFor(item) {
      return this.zoom_links[item.id] || null
    },
    toggleValueFor(item) {
      const zoomLink = this.zoomLinkFor(item)

      if (zoomLink) {
        return Boolean(zoomLink.status)
      }

      return Boolean(item.status || this.automateAll)
    },
    toggleDisabledFor(item) {
      return this.automateAll && !this.zoomLinkFor(item)
    },
    toggleClassAutomation(item, status) {
      if (this.toggleDisabledFor(item)) return
      this.initZoom(item, status)
    },
    initZoom(data, nextStatus) {
      var self = this;
      this.$store.commit('app/loadingState', true)
      var status = Boolean(nextStatus);
      var id = data.id;
      var date = data.start_date;
      const config = { id: id, status: status * 1, date: date, instructors: data.instructors }
      console.log(status)
      this.$http.post('https://live.ipstudio.co/api/zoom-link', config)
      .then(function (res) {
        var newzoomdata = {
          zoomurl: res.data.url || (self.zoom_links[id] && self.zoom_links[id].zoomurl) || '',
          status: status,
        }
        console.log(res)
        console.log(newzoomdata)
        self.zoom_links = {
          ...self.zoom_links,
          [id]: newzoomdata,
        }
        console.log(self.zoom_links[id])
        self.$store.commit('app/loadingState', false)
        if(res.data.msg == "Daily Limit Reached."){
          self.$swal({
            title: 'Daily Limit Reached!',
            text: ' Upgrade to pro version in order to automate more classes.',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            confirmButtonText: 'Upgrade to Pro',
            buttonsStyling: false,
          }).then(function() {
              var emailBody = "Thank you for upgrading to Live by IPSTUDIO™ pro, please state your business name and desired start date and a member of our team will active this upgrade for you.";
              window.location = "mailto:hello@ipstudio.co?cc=admin@ipstudio.co&subject=Upgrade%20us%20to%20Live%20By%20IPSTUDIO™%20Pro&body="+emailBody;
          });
        }
        else{
          self.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.msg,
              icon: 'SaveIcon',
              variant: res.data.status,
            }
          })
        }
      })
      .catch(function (error) {
        console.log(error)
        self.$store.commit('app/loadingState', false)
        self.$toast({
          component: ToastificationContent,
          props: {
            title: 'Something went wrong.',
            icon: 'AlertCircleIcon',
            variant: 'failed',
          }
        })
      })
    },
    triggerAutomateAll() {
      const config = { meta_key: 'automate', meta_value: JSON.stringify({"status": this.automateAll, "subdomain": this.$store.state.app.subdomain, "checked": []}) }
      this.$store.dispatch('app/saveUserMeta', config)
    },
  },
}
</script>

<style>
.automate-all-section {
    display: flex;
    justify-content: flex-end;
    margin-top: -45px;
    margin-bottom: 30px;
    align-items: center;
}
.automate-all-section .card-text {
    font-weight: bold;
    margin-right: 20px;
}
.automate-table th,
.automate-table td {
    vertical-align: middle;
}
.automate-table__class-column {
    min-width: 260px;
}
.automate-table__location {
    min-width: 150px;
}
</style>
